<script lang="ts">
    import type { Page } from '@shared/types/Tilelist';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import BottomPagingBar from '@tilelist/components/bottom-paging-bar/BottomPagingBar.svelte';
    import BottomPagingBarE3933 from '@tilelist/layouts/experiments/e3933/bottom-paging-bar/BottomPagingBar.svelte';

    interface Props {
        rankedCount: number;
        sponsoredCount: number;
        pageItemCount?: number;
        pageContext: Page;
        rule: string;
    }

    let { rankedCount, sponsoredCount, pageItemCount, pageContext, rule }: Props = $props();

    const onex = injectWiring().onex;
    const visualRefreshActive = $derived(onex.isExperimentGroup('VISUAL_REFRESH', 'E3933B'));
</script>

{#if visualRefreshActive}
    <BottomPagingBarE3933 {rankedCount} {sponsoredCount} {pageItemCount} {pageContext} {rule} />
{:else}
    <BottomPagingBar {rankedCount} {sponsoredCount} {pageItemCount} {pageContext} {rule} />
{/if}
